import { NgModule } from '@angular/core';
import { SharedModule } from 'app/shared/shared.module';
import { AssetDataPickerComponent } from './asset-data-picker.component';

@NgModule({
  declarations: [
    AssetDataPickerComponent
  ],
  imports: [
    SharedModule
  ],
  exports:[
    AssetDataPickerComponent
  ]
})
export class AssetDataPickerModule { }
